import styled from 'styled-components'
import { media } from '../utils/media'

export const IntakeStepNoColTablet = styled.div`
  display: none;
  ${media.tablet`
    flex: 0 0 auto;
    margin-right: 8px;
    display: block;
  `}
`



// WEBPACK FOOTER //
// ./src/atoms/IntakeStepNoColTablet.tsx